import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  email: 'Email',
}

export const emailApi = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.email],
  endpoints: {
    sendEmail: {
      // Specify tags for caching and invalidation
    },
  },
})

// Export hooks for usage in functional components
export const {
  useSendEmailMutation,
  // Export other hooks if necessary
} = emailApi
